<p-toast></p-toast>

<p-sidebar [(visible)]="visible" position="right"
		   (onHide)="cancel()"
		   [style]="{width:'635px'}">
	<ng-template pTemplate="header">
		<div class="partner-update-legal-doc-header" *ngIf="activeDocumentItem === documentTypeEnum.SECDocument">Edit SEC Document</div>
		<div class="partner-update-legal-doc-header" *ngIf="activeDocumentItem === documentTypeEnum.BIR2303">Edit BIR 2303</div>
		<div class="partner-update-legal-doc-header" *ngIf="activeDocumentItem === documentTypeEnum.BusinessPermit">Edit Business Permit</div>
	</ng-template>

	<div *ngIf="loading" style="text-align: center;">
		<p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="5" fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
	</div>

	<div class="partner-update-legal-doc-body">

	</div>
	
	<div class="flex justify-content-end mrg-10-0px">
		<button class="btn-darkblue" pButton label="Confirm" style="width: 91px; height: 45px;"></button>
	</div>

</p-sidebar>

